<template>
    <div :class="componentClasses">
        <img
            :src="avatarVariantImages[props.assistent.avatarVariant.value]"
            alt="Avatar icon"
        />
    </div>
</template>

<script setup lang="ts">
    import type { Assistent } from '@keyvue/one-api-client';
    import { computed } from 'vue';

    const props = withDefaults(defineProps<{
        assistent: Assistent,
        size?: 'lg' | 'xl'
    }>(), {
        size: 'lg',
    });

    const avatarVariantImages = computed(() => {
        const images = {
            variant1: '/avatars/1.png',
            variant2: '/avatars/2.png',
            variant3: '/avatars/3.png',
            custom: props.assistent.avatar?.url,
        };

        return images;
    });

    const componentClasses = computed(() => ({
        'assistent-avatar': true,
        [`assistent-avatar--size-${props.size}`]: true,
    }));
</script>

<style scoped lang="scss">
    .assistent-avatar {
        &--size-lg {
            width: size(lg);
            height: size(lg);
        }
        &--size-xl {
            width: size(xl);
            height: size(xl);
        }

        & > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            object-position: center 30%;
            border-radius: 50%;
        }
    }
</style>
